"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolProvider = exports.useSymbols = exports.useSymbolData = exports.useSymbolInfo = exports.useSymbolCoin = exports.useSymbol = exports.useSymbolAll = exports.SymbolContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SymbolDataProvider_1 = require("./SymbolDataProvider");
exports.SymbolContext = (0, react_1.createContext)(null);
const useSymbolAll = (isFocused = true) => {
    const [data, setData] = (0, react_1.useState)();
    const symbol = (0, react_1.useContext)(exports.SymbolContext);
    const hasSymbol = !!symbol;
    (0, react_1.useEffect)(() => {
        if (!isFocused || hasSymbol) {
            return;
        }
        const subscription = SymbolDataProvider_1.SymbolDataProvider.getSymbolDataObservable().subscribe({
            next: (data) => {
                setData(data);
            },
            error: () => { },
        });
        return () => subscription.unsubscribe();
    }, [isFocused, hasSymbol]);
    return symbol !== null && symbol !== void 0 ? symbol : data;
};
exports.useSymbolAll = useSymbolAll;
// 根据base和quote获取symbol信息
const useSymbol = (base, quote, isFocused = true) => {
    const symbolData = (0, exports.useSymbolAll)(isFocused);
    return (0, react_1.useMemo)(() => {
        if (!symbolData || !base || !quote) {
            return undefined;
        }
        return symbolData.symbolMap.get(`${base}/${quote}`);
    }, [symbolData, base, quote]);
};
exports.useSymbol = useSymbol;
// 根据coin获取symbol信息
const useSymbolCoin = (coin) => {
    const symbolData = (0, exports.useSymbolAll)();
    return (0, react_1.useMemo)(() => {
        if (!symbolData || !coin) {
            return undefined;
        }
        return symbolData.allSymbols.find((symbol) => symbol.base === coin);
    }, [symbolData, coin]);
};
exports.useSymbolCoin = useSymbolCoin;
// 根据symbol字符串获取symbol信息
const useSymbolInfo = (symbol) => {
    const symbolData = (0, exports.useSymbolAll)();
    return (0, react_1.useMemo)(() => {
        if (!symbolData || !symbol) {
            return undefined;
        }
        return symbolData.symbolMap.get(symbol);
    }, [symbolData, symbol]);
};
exports.useSymbolInfo = useSymbolInfo;
// 获取现货或者swapB的全部symbol信息
const useSymbolData = () => {
    const symbolData = (0, exports.useSymbolAll)();
    return (0, react_1.useMemo)(() => {
        const data = symbolData.spotSymbolData;
        return {
            allSymbols: data.symbols,
            symbolMap: data.map,
            quotes: data.quotes,
        };
    }, [symbolData.spotSymbolData]);
};
exports.useSymbolData = useSymbolData;
// 根据币对数组批量获取map信息
const useSymbols = (pairs) => {
    const symbolData = (0, exports.useSymbolAll)();
    return (0, react_1.useMemo)(() => {
        if (!(pairs === null || pairs === void 0 ? void 0 : pairs.length)) {
            return undefined;
        }
        return pairs.reduce((sum, { base, quote }) => {
            sum[`${base}/${quote}`] = symbolData.symbolMap.get(`${base}/${quote}`);
            return sum;
        }, {});
    }, [pairs, symbolData]);
};
exports.useSymbols = useSymbols;
function SymbolProvider({ children }) {
    const symbolData = (0, exports.useSymbolAll)();
    return (0, jsx_runtime_1.jsx)(exports.SymbolContext.Provider, Object.assign({ value: symbolData }, { children: children }));
}
exports.SymbolProvider = SymbolProvider;
